import { Form } from 'antd';
import Box from 'components/Box';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { StartTimes, TimeSelection, TimeSelectionRef } from './TimeDate';
import { IQuickBookingV2FormValues } from './type';
type Props = {
  timeRef: React.RefObject<TimeSelectionRef>;
  onPickDate: (date: moment.Moment) => Promise<void>;
  forceCalculateTime?: boolean;
};
const QuickBookingTimeContent = ({ timeRef, onPickDate, forceCalculateTime }: Props) => {
  const form = Form.useFormInstance();
  const onStartTimeChange = (startTime?: string) => {
    if (!startTime) return;
    const customerList: IQuickBookingV2FormValues['customerList'] = form.getFieldValue('customerList');
    const masterDuration: IQuickBookingV2FormValues['duration'] = form.getFieldValue('duration');
    form.setFieldValue('customerList', customerList.map(o => {
      let startDate = startTime || '';
      return ({
        ...o,
        services: o.services.map(s => {
          const result = ({
            ...s,
            startTime: startDate
          });
          if (forceCalculateTime || masterDuration === undefined) {
            startDate = moment(startDate || '', 'hh:mm A')
              .add(s.duration, 'minutes')
              .format('hh:mm A');
          }
          return result;
        })
      });
    }));
  };

  return (
    <Box display='flex' flexDirection='column' style={middleContainerStyle}>
      <OverflowBox>
        <Form.Item noStyle name={'defaultStaffId'} />
        <Form.Item noStyle name={'dayOffs'} />
        <Form.Item noStyle name={'activeServiceId'} />
        <Form.Item noStyle name={'date'} rules={[{ required: true }]}>
          <TimeSelection ref={timeRef} onPickDate={onPickDate} />
        </Form.Item>
        <Form.Item noStyle name={'startTime'} rules={[{ required: true }]}>
          <StartTimes onStartTimeChange={onStartTimeChange} />
        </Form.Item>
        <Box mb='4' />
      </OverflowBox>
    </Box>
  );
};

export default QuickBookingTimeContent;

const middleContainerStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 600,
  position: 'relative',
};
const OverflowBox = styled.div`
  position: absolute;
  inset: 0;
  overflow: auto;
  padding: 16px;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
